/**
 * Configuration tarifaire officielle Photobooth — Show Événement
 * Modèle : le forfait = un BUDGET MAXIMUM. On facture le RÉEL.
 *   Prix = 150 € (location, payés à la réservation) + 0,50 € par photo imprimée,
 *   plafonné au forfait choisi. Cadre personnalisable + lien galerie dans tous les cas.
 *
 * Source unique partagée par :
 *  - PhotoboothSelector (fiche produit client)
 *  - DevisEditor / DevisCreateModal (facturation des photos imprimées au réel)
 */

// Location machine payée à la réservation (machine + galerie + lien + cadre personnalisable)
export const PHOTOBOOTH_LOCATION = 150;

// Prix par photo imprimée, facturé au réel après l'événement
export const PHOTOBOOTH_PRIX_PHOTO = 0.50;

// Forfaits = budget MAXIMUM (plafond). nb = nombre de photos du forfait, max = budget plafond.
export const PHOTOBOOTH_FORFAITS = [
  { key: 'aucune', nb: 0,   label: 'Aucune impression', max: 150, color: '#5DBCBF' },
  { key: 'f200',   nb: 200, label: '200 photos',        max: 250, color: '#1F9D7A' },
  { key: 'f400',   nb: 400, label: '400 photos',        max: 300, color: '#D4AF37', popular: true },
  { key: 'f600',   nb: 600, label: '600 photos',        max: 350, color: '#C58B19' },
];

/**
 * Facturation au réel = meilleur tarif client :
 *   min( 150 € + 0,50 €/photo , plafond du forfait applicable ).
 * (Miroir exact du backend : pricing_engine.meilleur_tarif_photobooth)
 */
export function photoboothTotalReel(nb) {
  nb = parseInt(nb) || 0;
  let best = PHOTOBOOTH_LOCATION + PHOTOBOOTH_PRIX_PHOTO * nb;
  for (const f of PHOTOBOOTH_FORFAITS) {
    if (f.nb > 0 && nb <= f.nb) best = Math.min(best, f.max);
  }
  return Math.round(best * 100) / 100;
}

/** Coût de la seule ligne « photos imprimées » = total réel − location déjà payée. */
export function photoboothPrintsCost(nb) {
  return Math.round((photoboothTotalReel(nb) - PHOTOBOOTH_LOCATION) * 100) / 100;
}

/**
 * Option photobooth ajoutable à un devis : la LOCATION (150 €, acompte).
 * Les photos imprimées sont ensuite facturées au réel (bouton dédié dans l'éditeur).
 */
export const PHOTOBOOTH_DEVIS_OPTIONS = [
  {
    key: 'location',
    label: 'Photobooth — Location',
    description: `${PHOTOBOOTH_LOCATION}€ à la réservation · machine + galerie + lien + cadre personnalisable`,
    prix: PHOTOBOOTH_LOCATION,
  },
];
